/**
 * NOTE: This file is referenced from vite.config.js
 * If moved or renamed, please check out that the config is valid.
 */
import * as Sentry from '@sentry/react';

interface SentryInitOptions {
  /**
   * Sentry DSN.
   */
  dsn: string;
  /**
   * Current environment, e.g. "int", "dev", "eu10", "local"
   */
  environment: string;
  /**
   * Authenticated user ID. If it is an email (i.e., Personally Identifiable Information), it should be hashed.
   */
  userId: string;
  /**
   * ID of the tenant.
   */
  tenantId: string;
}

export default function initSentry({ dsn, environment, userId, tenantId }: SentryInitOptions) {
  return Sentry.init({
    // NOTE: The `release` is added to this config implicitly by Sentry Vite plugin!
    // See: vite.config.js
    dsn,
    environment,
    initialScope: {
      tags: {
        role: 'frontend',
      },
      user: {
        id: userId,
        tenant_id: tenantId,
      },
    },
    denyUrls: [/^chrome-extension:\/\//i],
  });
}
